import { useState, useEffect, useContext } from 'react';
import { reaction } from 'mobx';
import GlobalContext from 'contexts';

/** @returns {import("./store").default} */
export const useGlobalContext = () => useContext(GlobalContext);

/**
 * True after mount — use to avoid SSR/client HTML mismatch for MobX-driven subtrees.
 * @param dataToMount
 * @param [initialValue]
 *  */
export const useClientMounted = (dataToMount, initialValue) => {
  const [mounted, setMounted] = useState(initialValue);
  useEffect(() => {
    setMounted(dataToMount);
  }, [dataToMount]);
  return mounted;
};

export const useCurrentTime = () => {
  const [currTime, setCurrTime] = useState(() => Date.now());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrTime(Date.now());
      // getTime().then(t => setCurrTime(t)); // USE FOR REMOTE EVENTS ONLY
    }, 100);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return currTime;
};

export const useTiltifyUpdates = () => {
  const store = useGlobalContext();

  useEffect(() => {
    const intervalId = setInterval(() => {
      store.getEventData();
    }, 10000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(
    () =>
      reaction(
        () => store.fundky.id,
        () => {
          store.getEventData();
        },
      ),
    [],
  );
};
